import React, { useMemo } from "react";
import DigitalPipelineTable from "../../Components/Table/DigitalPipelineTable";

const DigitalPipelineContainer = ({ digital_performace }) => {
  const groupedData = useMemo(() => {
    if (!digital_performace?.data) return {};
    return digital_performace.data.reduce((acc, row) => {
      if (!acc[row.product_line]) acc[row.product_line] = [];
      acc[row.product_line].push({
        state: row.state_office,

        vals: [
          row.C0,
          row.C1,
          row.C1A,
          row.C2,
          row.C3,
          row.overall_C3,
          row["%C3_from_digital"]?.toFixed(1) + "%",
          row.C0_C3_percent?.toFixed(1) + "%",
          "-",
        ],
      });
      return acc;
    }, {});
  }, [digital_performace]);

  /* ✅ Required rendering sequence */
  const sequence = ["HCV Trucks", "ILMCV Trucks", "CV Passenger", "SCV & PU"];

  /* ✅ Sort product lines without affecting data */
  const sortedEntries = Object.entries(groupedData).sort(([a], [b]) => {
    const indexA = sequence.indexOf(a);
    const indexB = sequence.indexOf(b);

    if (indexA === -1 && indexB === -1) return a.localeCompare(b);
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  return (
    <div
      id="digitalPipelineSection"
      className="grid grid-cols-1 md:grid-cols-1 w-[400px] md:w-[1200px] gap-4"
    >
      {sortedEntries.map(([pl, data]) => (
        <DigitalPipelineTable key={pl} plName={pl} data={data} />
      ))}
    </div>
  );
};
export default DigitalPipelineContainer;
